import Shiki from '@shikijs/markdown-it'
import MarkdownIt from 'markdown-it'

const highlighters = new Map<boolean, Promise<any>>()

export async function getHighlighter(colorMode: string, allowImages = true) {
    // const theme = colorMode === 'light' ? 'github-light' : 'github-dark'
    const theme = 'github-dark'
    // AI/chat renderers must not fetch model-generated image URLs. Keep their
    // renderer separate so trusted editorial pages can still display images.
    if (!highlighters.has(allowImages)) {
        const pending = (async () => {
            const md = MarkdownIt({ html: false })
            if (!allowImages) md.disable('image')
            return md.use(await Shiki({
                theme: theme,
                langs: ['python', 'py', 'sh'],
                // User and AI messages can contain arbitrary fence labels such as mql5.
                // Preserve their code as escaped plain text when no grammar is loaded.
                // This adapter's v1 types omit Shiki's built-in plain-text language.
                fallbackLanguage: 'text' as Parameters<typeof Shiki>[0]['fallbackLanguage'],
            }))
        })()
        highlighters.set(allowImages, pending)
        // A failed grammar load may be retried without caching the rejection.
        pending.catch(() => highlighters.delete(allowImages))
    }
    return highlighters.get(allowImages)
}
